export const Basic = {
  install(Vue, options) {
    Vue.prototype.quickpop = (msg) => {
      alert(msg || 'Warning!')
    }
  },
}
